import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useContext } from "react";
import { useTheme } from "@emotion/react";
import PermContact from "src/assets/svg/permcontact.js";
import { Box, Typography, Button, Divider } from "@mui/material";
import { AuthContext } from "src/utils/AuthContext.js";
import { getPageRoute } from "src/services";
import { customEvent } from "src/utils/gtag.js";
import InstructionsLayout from "../InstructionsLayout.js";

const CalendarExperience = () => {
  const location = useLocation();
  const calendar = location.state?.calendar ?? null;
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const theme = useTheme();

  useEffect(() => {
    if (!calendar) {
      navigate(getPageRoute("home", "HOME"));
    }
  }, [calendar, navigate]);

  const handleConnectCalendar = () => {
    customEvent({
      name: "nav_other_calendar_steps_experience_page",
      category: "OtherCalendarExperience",
      label: "Navigate to Other Calendar Steps from Experience Page",
      data: {
        user_id: user._id,
        user_email: user.email,
        user_handle: user.handle ?? "no_handle",
      },
    });
    navigate(getPageRoute("help", "SUBSCRIBING_CALENDAR_STEPS"));
  };

  const handleSubscribeExperience = () => {
    navigate(getPageRoute("help", "SUBSCRIBING_CALENDAR_EXPERIENCE"), {
      state: { calendar },
    });
  };

  return (
    <InstructionsLayout nav="home">
      <PermContact />
      <Typography variant={"h2"} sx={{ mt: 1.5 }}>
        Your calendar app updates silently <br />in the background.
      </Typography>
      <Typography variant={"subtitle2"} sx={{ mt: 1.5 }}>
        You won't know when your calendar last updated <br /> and whether you
        have the latest events.
      </Typography>
      <Button
        variant="contained"
        size="grown"
        sx={{ mt: 6, width: "330px" }}
        onClick={handleConnectCalendar}
      >
        CONNECT YOUR CALENDAR
      </Button>
      <Typography
        variant={"subtitle2"}
        sx={{
          mt: 2,
          width: "330px",
        }}
      >
        Know <u>exactly</u> when your calendar last updated. <br />Force
        refresh if needed.
      </Typography>
      <Box sx={{ width: "100%", maxWidth: "330px" }}>
        <Divider sx={{ mt: 3, mb: 3.5 }}>
          <Typography variant="subtitle2" color="text.secondary">
            or
          </Typography>
        </Divider>
      </Box>
      <Button
        variant="outlined"
        size="grown"
        sx={{ width: "330px" }}
        onClick={handleSubscribeExperience}
      >
        STATUS QUO
      </Button>
      <Typography
        variant={"subtitle2"}
        sx={{
          mt: 2,
          width: "330px",
        }}
      >
        Hope for the best with silent updates and <br />
        <u>manually verify</u> that you have the latest events.
      </Typography>
    </InstructionsLayout>
  );
};

export default CalendarExperience;
